/**
 * The label to display when selected the filter
 */
export const labelTipologiaOrario = 'Tipologia Lavoro';
